export default {
  macaroniCheese: "#f6c836",
  orchid: "#bd7bc7",
  coralPink: "#fc6064",
  brownishGrey: "#707070",
  barneyPurple: "#9903af",
  goldenYellow: "#fdc91f",
  navy: "#01151d",
};
